import { useEffect, useRef, useState } from 'react';
export const useCountdown = (initialSeconds = 5)=>{
    const [seconds, setSeconds] = useState(initialSeconds);
    const [isRunning, setIsRunning] = useState(false);
    const intervalRef = useRef(null);
    useEffect(()=>{
        if (!process.env.BROWSER) return undefined;
        if (isRunning && seconds > 0) {
            intervalRef.current = setInterval(()=>{
                setSeconds((prev)=>{
                    if (prev <= 1) {
                        if (intervalRef.current) {
                            clearInterval(intervalRef.current);
                            intervalRef.current = null;
                        }
                        setIsRunning(false);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return ()=>{
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [
        isRunning,
        seconds
    ]);
    const start = ()=>{
        setSeconds(initialSeconds);
        setIsRunning(true);
    };
    const stop = ()=>{
        setIsRunning(false);
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };
    const reset = ()=>{
        setSeconds(initialSeconds);
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
        setIsRunning(false);
    };
    return {
        seconds,
        isRunning,
        start,
        stop,
        reset
    };
};
